/** 
  All of the routes for the Dreamer Admin Panel Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Dreamer Admin Panel Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Projects from "layouts/projects";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Dreamer Admin Panel Dashboard React icons
import Shop from "examples/Icons/Shop";
import UserDetail from "layouts/singleuser";
import ProjectDetail from "layouts/projectdetail";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import EditProject from "layouts/projectdetail/components/EditProject";
import Leaderboard from "layouts/leaderboard";
import Verified from "layouts/Verified";
import Streaks from "layouts/streaks";
import StreakForm from "layouts/streaks/components/streak-form";
import Badges from "layouts/badges";
import BadgeForm from "layouts/badges/components/badge-form";
import Levels from "layouts/levels";
import LevelForm from "layouts/levels/components/level-form";
import Tiers from "layouts/tiers";
import TierForm from "layouts/tiers/components/tier-form";
import Rules from "layouts/rules";
import ConfigForm from "layouts/rules/components/config-form";
import Rewards from "layouts/rewards";
import RewardForm from "layouts/rewards/components/reward-form";
import MilestoneReviewRequests from "layouts/MilestoneReviewRequests";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <Office size="12px" />,
    component: <Tables />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Projects",
    key: "projects",
    route: "/projects",
    icon: <Office size="12px" />,
    component: <Projects />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "UserDetail",
    key: "user-detail",
    route: "/user-detail",
    icon: <Office size="12px" />,
    component: <UserDetail />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "ProjectDetail",
    key: "project-detail",
    route: "/project-detail",
    icon: <Office size="12px" />,
    component: <ProjectDetail />,
    noCollapse: true,
    children: [
      {
        path: "edit",
        component: <EditProject />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Leaderboard",
    key: "leaderboard",
    route: "/leaderboard",
    component: <Leaderboard />,
    noCollapse: true,
    icon: <Document size="12px" />,
  },
  {
    type: "collapse",
    name: "Verifications",
    key: "verifications",
    route: "/verifications",
    component: <Verified />,
    noCollapse: true,
    icon: <Document size="12px" />,
  },
  
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   route: "/billing",
  //   icon: <CreditCard size="12px" />,
  //   component: <Billing />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Virtual Realitys",
  //   key: "virtual-reality",
  //   route: "/virtual-reality",
  //   icon: <Cube size="12px" />,
  //   component: <VirtualReality />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   route: "/rtl",
  //   icon: <Settings size="12px" />,
  //   component: <RTL />,
  //   noCollapse: true,
  // },
  { type: "title", title: "Gamifications", key: "gamifications" },
  {
    type: "collapse",
    name: "Tiers",
    key: "tiers",
    route: "/tiers",
    component: <Tiers />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <TierForm />,
      },
      {
        path: "edit",
        component: <TierForm />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Levels",
    key: "levels",
    route: "/levels",
    component: <Levels />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <LevelForm />,
      },
      {
        path: "edit",
        component: <LevelForm />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Rules",
    key: "rules",
    route: "/rules",
    component: <Rules />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <ConfigForm />,
      },
      {
        path: "edit",
        component: <ConfigForm />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Badges",
    key: "badges",
    route: "/badges",
    component: <Badges />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <BadgeForm />,
      },
      {
        path: "edit",
        component: <BadgeForm />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Streaks",
    key: "streaks",
    route: "/streaks",
    component: <Streaks />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <StreakForm />,
      },
      {
        path: "edit",
        component: <StreakForm />,
      }
    ]
  },


  {
    type: "collapse",
    name: "Rewards",
    key: "rewards",
    route: "/rewards",
    component: <Rewards />,
    noCollapse: true,
    icon: <Document size="12px" />,
    children: [
      {
        path: "add",
        component: <RewardForm />,
      },
      {
        path: "edit",
        component: <RewardForm />,
      }
    ]
  },
  {
    type: "collapse",
    name: "Project Review Requests",
    key: "milestone-review-requests",
    route: "/milestone-review-requests",
    component: <MilestoneReviewRequests />,
    noCollapse: true,
    icon: <Document size="12px" />,
  },


  { type: "title", title: "Account Pages", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",  
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   route: "/authentication/sign-up",
  //   icon: <SpaceShip size="12px" />,
  //   component: <SignUp />,
  //   noCollapse: true,
  // },
];

export default routes;
